export class LoadArea {
  public numLoadAreaId: number;
  public strLoadAreaCode = '';
  public strLoadArea = '';
  public numRegionId: number;
  public strLoadAreaCodeName = '';
}
